import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useGetCurrentSessionQuery } from '../app/api/sessionApi'
import { selectLoggedOut } from '../pages/layoutes/authLayout/authSlice'

export const useAuth = () => {
  // Skip /session/me after logout so the cleared cache cannot immediately re-fire,
  // hit 401 with no cookies, trigger a refresh that also fails, reset cache, and loop.
  const loggedOut = useSelector(selectLoggedOut)

  // Read only `isLoading` (true on the very first request when data is undefined).
  // Background refetches set `isFetching` but should not flash loading UI in callers
  // such as PrivateOutlet — otherwise the whole app blanks out on each cache refresh.
  const { data: session, isLoading, isError } = useGetCurrentSessionQuery(undefined, { skip: loggedOut })

  return useMemo(() => {
    // RTK Query keeps the cached entry around even when `skip:true`, so explicitly
    // ignore it once the user has logged out — otherwise navbar/role-gated UI would
    // keep showing the previous session's data until the cache is reset.
    const effectiveSession = loggedOut ? null : (session ?? null)
    return {
      session: effectiveSession,
      isAuthenticated: !!effectiveSession,
      isLoading: loggedOut ? false : isLoading,
      isError,
    }
  }, [isError, isLoading, session, loggedOut])
}
